import { CSSProperties } from 'react';
import { luca_ask_project_select_info } from '@/sub-luca-plugin/apis/qa';
import { getQaStore } from '@/sub-luca-plugin/store/qa';
import {
    IProjectConfig,
    ISubjectConfig,
    ITwoLevelSubjectConfig,
    ILucaAskConfigInfo,
    IProjectIdsAndNames,
    IProjectIds,
} from '@/sub-luca-plugin/types';

export type IReturnConfig = ILucaAskConfigInfo & IProjectIdsAndNames;

export interface IReturnProjectConfigOfSelected {
    subjects: ISubjectConfig[];
    projectId: number;
    projectName: string;
    aiAskOnOff: 0 | 1;
}

export type IProjectItem = IProjectConfig & {
    selected?: boolean;
};
export type ISubjectItem = ISubjectConfig & {
    selected?: boolean;
};
export type ITwoLevelSubjectItem = ITwoLevelSubjectConfig & {
    selected?: boolean;
};

export type IListItem = IProjectItem | ISubjectItem | ITwoLevelSubjectItem;

export interface ITabData {
    pid?: number;
    sid?: number;
    tsid?: number;
    name: string;
    isDetermined?: boolean;
    list: IListItem[];
    config?: ILucaAskConfigInfo;
    aiAskOnOff?: 0 | 1;
}

export type TReturnType = 'config' | 'subjects';

export interface IProjectSelectProps {
    /**
     *  项目数据
     */
    projects?: IProjectConfig[];
    /**
     * 外部传入确定的Id集
     */
    determinedIds?: IProjectIds;
    /**
     * 允许改变外部传入的确定的Id集
     */
    allowChangeDeterminedIds?: boolean;
    /**
     * 需要返回数据的类型
     */
    returnType?: TReturnType;
    overlayClassName?: string;
    className?: string;
    style?: CSSProperties;
    /**
     * 返回配置信息
     */
    onReturnConfig?: (config: IReturnConfig) => void;
    /**
     * 返回选中的项目配置
     */
    onReturnProjectConfig?: (config: IReturnProjectConfigOfSelected) => void;
    /**
     * 关闭选择
     */
    onClose?: () => void;
}

export const queryProjects = async (lucaId?: number) => {
    const list = getQaStore()?.getProjects();
    if (list?.length) return list;
    const { result } = await luca_ask_project_select_info({ lucaId: lucaId! });
    getQaStore()?.addProjects(result?.projects || []);
    return result?.projects || [];
};
